type AuthMessageProps = {
  type: 'error' | 'success';
  children: React.ReactNode;
};

export default function AuthMessage({ type, children }: AuthMessageProps) {
  const colorClass = type === 'error' ? 'text-red-500' : 'text-green-500';
  
  return (
    <div className={`${colorClass} text-sm text-center`}>
      {children}
    </div>
  );
}